import * as React from 'react'
import TextField from '@mui/material/TextField'
import Autocomplete from '@mui/material/Autocomplete'
import { Typography } from '@mui/material'

const FreezingSetting = ({ columns, handleFreeze, freezeColumnId, hiddenColumns }) => {
  const updatedFreezingSetting = columns.map((setting) => {
    if (setting.path.endsWith('__')) {
      return {
        ...setting,
        path: setting.path.replace(/__$/, ''),
      }
    }
    return setting
  })

  const options = updatedFreezingSetting
    ?.filter((col) => !hiddenColumns?.includes(Number(col.path)))
    .map((col) => ({
      label: col.name,
      value: col.path,
    }))

  const handleChange = (event, value) => {
    if (value) {
      handleFreeze(value.value)
    }
  }

  const handleUnFreeze = () => {
    handleFreeze([])
  }

  const frozenColumn = updatedFreezingSetting.find((col) => col.path == freezeColumnId?.toString())

  return (
    <div>
      <div style={{ display: 'flex', justifyContent: 'space-between', margin: '1rem 0' }}>
        <Typography className="fontWeight600 fontsize16" variant="h5">
          Freeze Column upto
        </Typography>

        {frozenColumn && Object.keys(frozenColumn).length > 0 && (
          <Typography
            sx={{ fontSize: '12px', marginTop: '6px', cursor: 'pointer', color: 'blue' }}
            onClick={handleUnFreeze}
          >
            Unfreeze
          </Typography>
        )}
      </div>

      <Autocomplete
        disablePortal
        options={options}
        sx={{ width: 'auto' }}
        onChange={handleChange}
        value={frozenColumn ? { label: frozenColumn.name, value: frozenColumn.path } : null}
        renderInput={(params) => (
          <TextField sx={{ padding: '0px' }} {...params} label="Select Column" />
        )}
      />
    </div>
  )
}

export default FreezingSetting
